/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useState } from 'react';
import { observer } from 'mobx-react';
import { Paper } from '@roc/ui';
import { Theme } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { Layout, StepperComponent } from '@roc/client-portal-shared/components';
import { useStore } from '../../hooks';
import { InformationStep } from './informationStep';
import PointOfContactStep from './pointOfContactStep';
import AcknowledgmentStep from './acknowledgmentStep';
import PaymentStep from './paymentStep';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3, 0, 4),
      borderRadius: theme.spacing(2),
      boxShadow:
        'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
    },
    stepper: {
      maxWidth: 900,
      margin: 'auto',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(.5),
        paddingRight: theme.spacing(.5),
      },
    },
    stepContentWrapper: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
  })
);

export const ValuationPayment = observer(() => {
  const [activeStep, setActiveStep] = useState(0);
  const classes = useStyles();
  const { valuationPaymentStore } = useStore();

  const showPointOfContactStep = !valuationPaymentStore.valuationInfo?.hidePointOfContactStep;

  const handleStep = (index: number) => setActiveStep(index);
  const handleBackStep = () => setActiveStep(activeStep - 1);
  const handleNextStep = () => setActiveStep(activeStep + 1);

  const valuationSteps = [
    {
      title: 'Valuation Information',
      render: () => <InformationStep handleNextStep={handleNextStep} />,
    },
    ...(showPointOfContactStep
      ? [
          {
            title: 'Point of Contact',
            render: () => (
              <PointOfContactStep
                handleBackStep={handleBackStep}
                handleNextStep={handleNextStep}
              />
            ),
          },
        ]
      : []),
    {
      title: 'Agreement',
      render: () => (
        <AcknowledgmentStep
          handleBackStep={handleBackStep}
          handleNextStep={handleNextStep}
        />
      ),
    },
    {
      title: 'Payment',
      render: () => <PaymentStep />,
    },
  ];

  const currentStep = valuationSteps[activeStep] ?? valuationSteps[0];

  return (
    <Layout>
      <Box my={3}>
        <Typography variant="h3" gutterBottom>
          {'Valuation Payment'}
        </Typography>
      </Box>
      <Paper className={classes.paper}>
        <StepperComponent
          activeStep={activeStep}
          disableNavigation={true}
          handleStep={handleStep}
          steps={valuationSteps.map(step => ({ title: step.title, icon: null }))}
          className={classes.stepper}
        />
        <Box mt={3} className={classes.stepContentWrapper}>
          {currentStep.render()}
        </Box>
      </Paper>
    </Layout>
  );
});
